import { render, staticRenderFns } from "./CorporateAuthor.vue?vue&type=template&id=23ffd904&scoped=true&"
import script from "./CorporateAuthor.vue?vue&type=script&lang=js&"
export * from "./CorporateAuthor.vue?vue&type=script&lang=js&"
import style0 from "./CorporateAuthor.vue?vue&type=style&index=0&id=23ffd904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffd904",
  null
  
)

export default component.exports